import { AxiosResponse } from 'axios';
import api from './Api'

export const getCreatePayInfoDataByMemberIdAndMemberMobileWellnessTicketId = (wellnessTicketId: string): Promise<AxiosResponse<IPayInfoBasicWebResponseV2>> => {
    return api.get(`/pay-info/web/v2/${wellnessTicketId}`)
}